import React, { useEffect, useState } from 'react'
import { Grid, Table } from '@scuf/common'
import baseServices from '../../../services/base.services'

const TablaQuimicosDomo2 = () => {
    const [state, setState] = useState(null)

    let headerTable = ['Nombre', 'Porcentaje']

    useEffect(() => {
        const getTTeg = async () => {
            try {
                var response = await baseServices.getTostacionModeloDomo({ opcion: 3 })
                if (response.data && response.data.length > 0) setState(response.data)
            }
            catch (e) {
                console.log(e)
                getTTeg()
            }
        }
        getTTeg()
    }, [])

    return (
        <>
            {state &&
                <>
                    <Grid.Row>
                        <Grid.Column xsWidth={12} width={6}>
                            <Table>
                                <Table.Header>
                                    {headerTable.map(x => <Table.HeaderCell content={x} />)}
                                </Table.Header>
                                <Table.Body>
                                    {
                                        state.map((x, i) =>
                                            i < 3 &&
                                            <Table.Row>
                                                <Table.Cell>
                                                    {x.Nombre}
                                                </Table.Cell>
                                                <Table.Cell>
                                                    {x.Valor} %
                                                </Table.Cell>
                                            </Table.Row>
                                        )
                                    }
                                </Table.Body>
                            </Table>
                        </Grid.Column>
                        <Grid.Column xsWidth={12} width={6}>
                            <Table>
                                <Table.Header>
                                    {headerTable.map(x => <Table.HeaderCell content={x} />)}
                                </Table.Header>
                                <Table.Body>
                                    {
                                        state.map((x, i) =>
                                            i > 2 &&
                                            <Table.Row>
                                                <Table.Cell>
                                                    {x.Nombre}
                                                </Table.Cell>
                                                <Table.Cell>
                                                    {x.Valor} %
                                                </Table.Cell>
                                            </Table.Row>
                                        )
                                    }
                                </Table.Body>
                            </Table>
                        </Grid.Column>
                    </Grid.Row>

                </>
            }
        </>
    )
}

export default TablaQuimicosDomo2
